type Props = {
  sqSize: number;
  strokeWidth: number;
  percentage: number;
  color: string;
};

export const CircularProgress = ({
  sqSize,
  strokeWidth,
  percentage,
  color,
}: Props) => {
  const targetPercentage = percentage || 0;
  const radius = (sqSize - strokeWidth) / 2;
  const viewBox = `0 0 ${sqSize} ${sqSize}`;
  const dashArray = radius * Math.PI * 2;
  const dashOffset = dashArray - (dashArray * targetPercentage) / 100;

  return (
    <svg
      width={sqSize}
      height={sqSize}
      viewBox={viewBox}
      role="progressbar"
      aria-label="Upload progress"
      aria-valuenow={targetPercentage}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <circle
        className="stroke-p-white-170"
        fill="none"
        cx={sqSize / 2}
        cy={sqSize / 2}
        r={radius}
        strokeWidth={`${strokeWidth}px`}
      />
      <circle
        className="transition-all"
        stroke={color}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        cx={sqSize / 2}
        cy={sqSize / 2}
        r={radius}
        strokeWidth={`${strokeWidth}px`}
        // Start progress marker at 12 O'Clock
        transform={`rotate(-90 ${sqSize / 2} ${sqSize / 2})`}
        style={{
          strokeDasharray: dashArray,
          strokeDashoffset: dashOffset,
        }}
      />
    </svg>
  );
};
